import { nextTick, reactive, ref, watch } from 'vue'
import type { UnsavedChangesDialogProps } from '../router-types'

// A globally reactive variable.
export const leaveWithUnsavedChangesAnswer = ref<undefined | 'pending' | 'yes' | 'no'>()

// A globally reactive variable.
export const unsavedChangesDialog = reactive<UnsavedChangesDialogProps>({
  showDialog: false
})

export function useUnsavedChangesDialog() {
  // let timeoutFn: ReturnType<typeof setTimeout> | undefined = undefined

  function closeUnsavedChangesDialog() {
    // clearTimeout(timeoutFn);
    unsavedChangesDialog.showDialog = false
    // timeoutFn = setTimeout(() => {
    //   leaveWithUnsavedChanges.value = undefined;
    // },1000)
    nextTick(() => {
      leaveWithUnsavedChangesAnswer.value = undefined
    })
  }

  function showUnsavedChangesDialog(
    onUnsavedChangesDialogAnswered: (discardChanges: 'yes' | 'no') => void,
    dialogProps?: Partial<Omit<UnsavedChangesDialogProps, 'showDialog'>>
  ) {
    unsavedChangesDialog.showDialog = true
    leaveWithUnsavedChangesAnswer.value = 'pending'
    const unWatch = watch(
      () => leaveWithUnsavedChangesAnswer.value,
      (answer) => {
        if (onUnsavedChangesDialogAnswered && (answer === 'yes' || answer === 'no')) {
          onUnsavedChangesDialogAnswered(answer)
          closeUnsavedChangesDialog()
          unWatch()
        }
      }
    )
  }

  function answerDialogPrompt(answer: 'yes' | 'no') {
    leaveWithUnsavedChangesAnswer.value = answer
  }

  return {
    closeUnsavedChangesDialog,
    showUnsavedChangesDialog,
    answerDialogPrompt,
    props: unsavedChangesDialog
  }
}
